// x-media-fullscreen-ck5.js

/*
This script:
- Calculates viewport height on touch-devices.
- Sets classes used for fullscreen group transitions.
*/

export default function xMediaFullscreenCK5() {

  // Only run on article page
  if (document.body.id === "vrtx-structured-article") {

    // Don't run if in iframe (preview mode)
    // Doing it like this due to problems detecting vrtx-preview-mode class
    if (window !== window.parent) {
      return;
    }

    const fullscreenMedia = document.querySelectorAll("img.fullscreen, .background-video video");
    const fullscreenGroups = document.querySelectorAll(".fullscreen-group");

    // Fullscreen media touch device viewport handling
    if (fullscreenMedia.length) {
      fullscreenMedia.forEach(media => {
        const figure = media.closest("figure");
        const isTouchDevice = "ontouchstart" in window;

        // Get largest viewport height and set as CSS variable
        // Doing this since vh for iOS varies with toolbar presence on scroll
        if (isTouchDevice) {
          function setViewportLargestHeight(value) {
            figure.style.setProperty('--viewport-largest-height', `${value}px`);
          }

          // Set initial viewport height
          let viewportLargestHeight = window.innerHeight;
          setViewportLargestHeight(viewportLargestHeight);

          // Update largest viewport height
          window.addEventListener('resize', () => {
            const currentHeight = window.innerHeight;
            if (currentHeight > viewportLargestHeight) {
              viewportLargestHeight = currentHeight;
              setViewportLargestHeight(viewportLargestHeight);
            }
          });
        }
      });
    }

    // Fullscreen group
    // Detect scroll positions for group and figures, then add/remove classes accordingly
    window.addEventListener('scroll', function() {
      fullscreenGroups.forEach((group) => {

        // When group fully occupies viewport, add active class
        const groupArea = group.getBoundingClientRect();
        if (groupArea.top <= 0 && groupArea.bottom >= window.innerHeight) {
          group.classList.add('active');
        } else {
          group.classList.remove('active');
        }

        // When figure fully occupies viewport, add active class
        const figures = group.querySelectorAll("figure");
        figures.forEach((figure) => {
          const figureArea = figure.getBoundingClientRect();
          if (figureArea.top <= 0 && figureArea.bottom >= window.innerHeight) {
            figure.classList.add('active');
          } else {
            figure.classList.remove('active');
          }
        });
      });
    });
  }
}
